!(function (window, document) {
  window.WxLogin = function (options) {
    var self_redirect = 'default'
    if (options.self_redirect === true) {
      self_redirect = 'true'
    } else if (options.self_redirect === false) {
      self_redirect = 'false'
    }

    var iframe = document.createElement('iframe')
    var url = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + options.appid +
      '&scope=' + options.scope +
      '&redirect_uri=' + options.redirect_uri +
      '&state=' + options.state +
      '&login_type=jssdk' +
      '&self_redirect=' + self_redirect +
      '&styletype=' + (options.styletype || '') +
      '&sizetype=' + (options.sizetype || '') +
      '&bgcolor=' + (options.bgcolor || '') +
      '&rst=' + (options.rst || '')

    if (options.style) url += '&style=' + options.style
    if (options.href) url += '&href=' + options.href
    if (options.lang === 'en') url += '&lang=en'
    if (options.stylelite === 1) url += '&stylelite=1'
    if (options.fast_login === 0) url += '&fast_login=0'

    if (options.color_scheme === 'auto') {
      url += '&color_scheme=auto'
    } else if (options.color_scheme === 'dark') {
      url += '&color_scheme=dark'
    } else if (options.color_scheme === 'light') {
      url += '&color_scheme=light'
    }

    iframe.src = url
    iframe.frameBorder = '0'
    iframe.allowTransparency = 'true'
    iframe.scrolling = 'no'
    iframe.width = '300px'
    iframe.height = '400px'

    var container = document.getElementById(options.id)
    container.innerHTML = ''
    container.appendChild(iframe)

    if (window.addEventListener && window.JSON && options.onReady && typeof options.onReady === 'function') {
      var messageHandler = function (event) {
        if (event.origin === 'https://open.weixin.qq.com') {
          try {
            var data = JSON.parse(event.data)
            if (data && data.type === 'status') {
              var ready = data.status === 'wxReady'
              if (ready) options.onReady(ready)
            }
          } catch (error) {
            if (window.console && typeof window.console.log === 'function') {
              window.console.log('wxLogin postMessage error', error)
            }
          }
        }
      }

      window.addEventListener('message', messageHandler, false)

      var cleaned = false
      options.onCleanup = function () {
        if (!cleaned && window.removeEventListener) {
          window.removeEventListener('message', messageHandler, false)
          cleaned = true
        }
      }
    }
  }
})(window, document)
export const WxLogin = window.WxLogin